<template>
    <div class="preachingDetails">
        <div class="banner">
            <img class="banner"
                 src="@/assets/images/155756396222.png">
        </div>
        <div class="Crumbs">
            <breadcrumb />
        </div>
        <div class="title">
            <h3>{{zaArticle.title}}</h3>
            <p>宣讲日期 :{{zaArticle.preachDate|formatDate}}</p>
        </div>
        <div class="content"
             v-html="zaArticle.content">

            <!-- <h4>尊敬的壹米滴答客户：</h4>
            <p>您好！据中央气象台最新预报，未来三天，陕西南部、重庆东南部、湖北南部、湖南西部和北部、贵州中东部、江西北部、安徽中南部、江苏南部、浙江西北部、西藏东部、青海南部等地的部分地区有中到大雪或雨夹雪，局地暴雪；贵州中南部、湖南西南部等地的部分地区有冻雨，以上地区受风雪天气影响，货物中转、收派时效会受到不同程度影响，请广大消费者予以理解，给您带来不便，我们十分抱歉！
            </p>
            <div class="inscription">
                <p>壹米滴答供应链集团有限公司</p>
                <p>2018年12月08日</p>
            </div> -->
        </div>
    </div>
</template>

<script>
import { queryById } from "@/api/zpArticleApi";
import breadcrumb from "@/components/breadcrumb";
export default {
    components: {
        breadcrumb
    },
    data() {
        return {
            zaArticle: {}
        };
    },
    created() {
        // 详情页获取
        // this.ruleForm.post = this.$route.query.contentid;
        console.log(this.$route.query.contentid);
        let id = this.$route.query.contentid;
        if (id) {
            this.getIdZpArticle(id);
        }
    },
    mounted() {},
    methods: {
        getIdZpArticle(id) {
            if (id) {
                queryById({ id: id }).then(res => {
                    if (res.status === 2000) {
                        this.zaArticle = res.data;
                    } else if (res.status === 4102) {
                        this.$message({
                            message: res.data[0].errorMsg,
                            type: "warning"
                        });
                    }
                });
            }
        }
    }
};
</script>


<style scoped lang="scss">
.preachingDetails {
    background-color: #f5f6f7;
    padding-bottom: 60px;
    .banner {
        width: 100%;
    }
    .title {
        text-align: center;
        padding-top: 40px;
        padding-bottom: 60px;
        p {
            margin-top: 20px;
        }
    }
    .content {
        margin: 0 auto;
        padding: 40px;
        padding-bottom: 160px;
        width: 1200px;
        background-color: #fff;
        h4 {
            padding-top: 40px;
        }
        p {
            color: #333;
            font-size: 15px;
            line-height: 26px;
            margin-top: 20px;
        }
        .inscription {
            float: right;
            position: relative;
            p {
                color: #221815;
                margin: 0;
            }
            p:nth-child(1) {
                margin-top: 60px;
            }
        }
    }
}
</style>
